const GamificationScreens = {
  GAMIFICATION: {
    PATH: '/gamification',
    TITLE: 'Gamification',
    TITLE_ALT: 'Gamification',
    PERMISSION: 'gamification.read',
  },
  LIST_GAMIFICATION: {
    PATH: '/gamification/index',
    TITLE: 'List Gamification',
    TITLE_ALT: 'List',
    PERMISSION: 'gamification.read',
  },
  ADD_GAMIFICATION: {
    PATH: '/gamification/add',
    TITLE: 'Add Gamification',
    TITLE_ALT: 'Add Gamification',
    PERMISSION: 'gamification.create',
  },
  DETAIL_GAMIFICATION: {
    PATH: '/gamification/detail/:id',
    TITLE: 'Gamification Detail',
    TITLE_ALT: 'Detail',
    PERMISSION: 'gamification.read',
  },
  EDIT_GAMIFICATION: {
    PATH: '/gamification/edit/:id',
    TITLE: 'Edit Gamification',
    TITLE_ALT: 'Edit',
    PERMISSION: 'gamification.update',
  },
  REPORT_GAMIFICATION: {
    PATH: '/gamification/report/:id',
    TITLE: 'Gamification Report',
    TITLE_ALT: 'Report',
    PERMISSION: 'gamification.read',
  },
};

export default GamificationScreens;
